// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1mG__","title":"styles_title__21tTb"};